var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgPanelLeftClose = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, className: "lucide lucide-panel-left-close-icon lucide-panel-left-close", viewBox: "0 0 24 24" }, props, { children: [_jsx("rect", { width: 18, height: 18, x: 3, y: 3, rx: 2 }), _jsx("path", { d: "M9 3v18M16 15l-3-3 3-3" })] }))); };
export default SvgPanelLeftClose;
